
import { createRoot } from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import WrappedApp from "./App";
import "./styles/style.css";
import store from "./redux/store";

const container = document.getElementById("root");
const params = new URLSearchParams(window.location.search);
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <WrappedApp />
  </Provider>
);

reportWebVitals();
